import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Theme = 'light' | 'dark'

interface UserProfile {
  id: string
  line_uid: string
  display_name: string | null
  avatar_url: string | null
  role: 'user' | 'admin' | 'super_admin' | null
  unlocked_gurus: { guru_id: string; draw_id: string; expires_at: string }[]
  dream_quota: {
    used_today: boolean
    free_per_day: number
    paid_tickets: number
  }
  checkin?: {
    checked_in_today: boolean
  }
}

interface AppStore {
  lineUid: string | null
  profile: UserProfile | null
  setLineUid: (uid: string) => void
  setProfile: (profile: UserProfile) => void
  clearUser: () => void

  // Theme
  theme: Theme
  setTheme: (t: Theme) => void
  toggleTheme: () => void

  isLoading: boolean
  setLoading: (v: boolean) => void
  error: string | null
  setError: (msg: string | null) => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set, get) => ({
      lineUid: null,
      profile: null,
      setLineUid: (uid) => set({ lineUid: uid }),
      setProfile: (profile) => set({ profile }),
      clearUser: () => set({ lineUid: null, profile: null }),

      theme: 'light',
      setTheme: (t) => {
        document.documentElement.setAttribute('data-theme', t)
        set({ theme: t })
      },
      toggleTheme: () => {
        const next = get().theme === 'light' ? 'dark' : 'light'
        document.documentElement.setAttribute('data-theme', next)
        set({ theme: next })
      },

      isLoading: false,
      setLoading: (v) => set({ isLoading: v }),
      error: null,
      setError: (msg) => set({ error: msg }),
    }),
    {
      name: 'amulet-digit-store',
      partialize: (s) => ({ lineUid: s.lineUid, theme: s.theme }),
      onRehydrateStorage: () => (state) => {
        if (state?.theme) {
          document.documentElement.setAttribute('data-theme', state.theme)
        }
      },
    },
  ),
)
